import { Suspense, lazy } from "react";
import { useData } from "vike-react/useData";
import HeroSection from "@/components/landing/HeroSection";
import type { IndexPageData } from "./+data";

const AgitationSection = lazy(
  () => import("@/components/landing/AgitationSection"),
);
const SolutionSection = lazy(
  () => import("@/components/landing/SolutionSection"),
);
const LeadCaptureForm = lazy(
  () => import("@/components/landing/LeadCaptureForm"),
);
const BlogInsightsGrid = lazy(
  () => import("@/components/landing/BlogInsightsGrid"),
);
const CtaBanner = lazy(() => import("@/components/landing/CtaBanner"));

const SectionFallback = () => (
  <div className="h-64 w-full animate-pulse bg-surface-elevated/40" />
);

const CtaFallback = () => (
  <div className="h-48 w-full animate-pulse bg-background" />
);

export default function Page() {
  const { featuredArticles } = useData<IndexPageData>();

  return (
    <>
      <HeroSection />
      <Suspense fallback={<SectionFallback />}>
        <AgitationSection />
        <SolutionSection />
        <LeadCaptureForm />
        <BlogInsightsGrid articles={featuredArticles} />
        <Suspense fallback={<CtaFallback />}>
          <CtaBanner variant="section" />
        </Suspense>
      </Suspense>
    </>
  );
}
